import { TopMenuItem } from "../../common/models/top-menu-item.model";

export class CRMTopMenu{
    TopMenuItems: Array<TopMenuItem> 
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/crm-top-menu.model.ts